import { render, staticRenderFns } from "./PatchNotes.vue?vue&type=template&id=2b43aa2c&scoped=true"
import script from "./PatchNotes.vue?vue&type=script&lang=js"
export * from "./PatchNotes.vue?vue&type=script&lang=js"
import style0 from "./PatchNotes.vue?vue&type=style&index=0&id=2b43aa2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b43aa2c",
  null
  
)

export default component.exports